import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  menuActive: [false, false, false, true, false],
  menuTemp: [false, false, false, false, false],
  activeTabBarId: 0,
  isReview: false,
  isShowMenu: true,
  isShowMenuToolbar: true,
  isShowProduct: false,
  isShowSharing: false,
  isLoaded: false,
  isLoading: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setMenuActive: (state, action) => {
      state.menuActive = action.payload; // expects array of booleans
    },
    setIsReview: (state, action) => {
      state.isReview = action.payload; // expects boolean
    },
    setActiveTabBarId: (state, action) => {
      state.activeTabBarId = action.payload;
    },
    setMenuTemp: (state, action) => {
      state.menuTemp = action.payload; // expects array of booleans
    },
    setIsShowMenu: (state, action) => {
      state.isShowMenu = action.payload; // expects boolean
    },
    setIsShowMenuToolbar: (state, action) => {
      state.isShowMenuToolbar = action.payload; // expects boolean
    },
    setIsShowProduct: (state, action) => {
      state.isShowProduct = action.payload; // expects boolean
    },
    setIsShowSharing: (state, action) => {
      state.isShowSharing = action.payload; // expects boolean
    },
    setIsLoaded: (state, action) => {
      state.isLoaded = action.payload; // expects boolean
    },
    toggleMenuItem: (state, action) => {
      const index = action.payload; // expects index to toggle
      if (index >= 0 && index < state.menuActive.length) {
        state.menuActive[index] = !state.menuActive[index];
      }
    },
    toggleIsShowMenu: (state) => {
      state.isShowMenu = !state.isShowMenu;
    },
    toggleIsShowMenuToolbar: (state) => {
      state.isShowMenuToolbar = !state.isShowMenuToolbar;
    },
    toggleIsShowProduct: (state) => {
      state.isShowProduct = !state.isShowProduct;
    },
    toggleIsShowSharing: (state) => {
      state.isShowSharing = !state.isShowSharing;
    },
    toggleIsReview: (state) => {
      state.isReview = !state.isReview;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload; // expects boolean
    },
  },
});

export const {
  setMenuActive,
  setActiveTabBarId,
  setIsReview,
  setMenuTemp,
  setIsShowMenu,
  setIsShowMenuToolbar,
  setIsShowProduct,
  setIsShowSharing,
  setIsLoaded,
  setLoading,
  toggleMenuItem,
  toggleIsShowMenu,
  toggleIsShowMenuToolbar,
  toggleIsShowProduct,
  toggleIsShowSharing,
  toggleIsReview,
} = uiSlice.actions;

export default uiSlice.reducer;
